import { useRef, useState } from "react";

// The stamp card demo: add visits until the goal unlocks a reward, then the
// staff mark it redeemed, which starts the card again.
export function useStampCard(total: number) {
  const initialState = { visits: 0 };
  const [state, setState] = useState(initialState);
  // Focus returns to "Add a visit" after the reward is redeemed, since the
  // reward panel (and its button) disappears.
  const addRef = useRef<HTMLButtonElement>(null);

  const addVisit = () =>
    setState((state) => ({ ...state, visits: Math.min(total, state.visits + 1) }));
  const reset = () => setState((state) => ({ ...state, visits: 0 }));
  const redeem = () => {
    reset();
    // The add button is disabled until this render commits.
    requestAnimationFrame(() => addRef.current?.focus());
  };

  return {
    visits: state.visits,
    isUnlocked: state.visits >= total,
    addVisit,
    reset,
    redeem,
    addRef,
  };
}
